const state = {
    products: [
      { id: 1, name: "Asus Vivobook X515MA", price: "35,500", stockLimit: 20 },
      { id: 2, name: "Dell E1916HV 18.5 Inch", price: "9,300", stockLimit: 35 },
      { id: 3, name: "Canon Eos 4000D 18MP", price: "36,500", stockLimit: 72 },
    ],
    carts: [],
    totalPrice: 0,
    totalItem: 0,
  };
  
  export default state;
  